import { literal, object, string } from "superstruct";

import type { ContextBase, PathParamsBase } from "../endpoint/Endpoint.js";
import Endpoint from "../endpoint/Endpoint.js";
import EndpointRouter from "../endpoint/EndpointRouter.js";

export default function buildIamRouter(base: EndpointRouter<PathParamsBase, ContextBase>) {
    const router = base.addRouter(
        new EndpointRouter<PathParamsBase, ContextBase>().setPath("/iam", object({})),
    );
    const endpoints = {
        // IAM
        emailCodeEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath("/auths/email/code", object({}))
                .setResultParser(literal(null))
                .setBodySchema(object({ email: string() })),
        ),
        emailCodeConfirmEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath("/auths/email/code/confirm", object({}))
                .setResultParser(literal(null))
                .setBodySchema(object({ email: string(), code: string() })),
        ),
        anonymousIdsEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath("/auths/anonymous/ids", object({}))
                .setResultParser(object({ id: string() })),
        ),
        anonymousSignupEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath("/auths/anonymous/signup", object({}))
                .setResultParser(literal(null))
                .setBodySchema(object({ id: string(), password: string() })),
        ),
        anonymousLoginEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath("/auths/anonymous/login", object({}))
                .setResultParser(literal(null))
                .setBodySchema(object({ id: string(), password: string() })),
        ),
        logoutEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath("/auths/logout", object({}))
                .setResultParser(literal(null)),
        ),
    };
    return { router, endpoints };
}
